import type { MongoAbility } from "@casl/ability";

/**
 * RBAC resource and action constants.
 * These must match the seeded values in the permissions table.
 */
export const RESOURCES = {
  SYSTEM: "system",
  USERS: "users",
  USERS_PROFILE_MEDIA: "users.profile-media",
  MENTORSHIPS: "mentorships",
  ESCALATIONS: "escalations",
  MESSAGES: "messages",
  DOCUMENTATION: "documentation",
  SESSIONS: "sessions",
  SURVEYS: "surveys",
  ANALYTICS: "analytics",
  ADMIN_ANALYTICS: "admin-analytics",
  MENTOR_METRICS_DASHBOARD: "mentor-metrics-dashboard",
  MENTOR_METRICS_DASHBOARD_LEAD_FILTER: "mentor-metrics-dashboard.lead-filter",
  MENTOR_SCORING: "mentor-scoring",
  MENTOR_SLOTS: "mentor-slots",
  MENTOR_STORIES: "mentor-stories",
  EXPORTS: "exports",
  GROUPS: "groups",
  SETTINGS: "settings",
  CAMPAIGN_CODES: "campaign-codes",
  PAYOUTS: "payouts",
  ONBOARDING: "onboarding",
  ONBOARDING_MESSAGES: "onboarding-messages",
  REFERRALS: "referrals",
  CONTENT_MODERATION: "content-moderation",
  CARE: "care",
  AVA: "ava",
  SUPERVISOR: "supervisor",
  TEEN_ACCESS: "teen-access",
  KNOWLEDGE_BASE: "knowledge-base",
  RISK_FLAGGING: "risk-flagging",
  CALENDAR_EVENTS: "calendar-events",
  SHAREABLE_ENTITIES: "shareable-entities",
  CALLS: "calls",
  PROFILE_SECTIONS: "profile-sections",
  NOTIFICATIONS: "notifications",
  ROLES: "roles",
  ACTIVITIES: "activities",
  MENTEE_PII: "mentee_pii",
  MENTEE_PHI: "mentee_phi",
  INTERNAL_MESSAGES: "internal-messages",
  INTERNAL_CHANNELS: "internal-channels",
  SMS_LIFECYCLE: "sms-lifecycle",
  TRAINING_SIMULATOR: "training-simulator",
  TRAINING_SIMULATOR_REVIEWS: "training-simulator-reviews",
  TRAINING_SIMULATOR_CONTENT: "training-simulator-content",
  MENTOR_PROFILE: "mentor-profile",
  MENTOR_PROFILE_REVIEWS: "mentor-profile-reviews",
} as const;

export const ACTIONS = {
  MANAGE_ALL: "manage-all",
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
  SHARE: "share",
  HIDE: "hide",
  RSVP: "rsvp",
  ASSIGN: "assign",
  UNASSIGN: "unassign",
} as const;

export type Resource = (typeof RESOURCES)[keyof typeof RESOURCES] | "all";
export type Action = (typeof ACTIONS)[keyof typeof ACTIONS] | "manage";

export type AppAbility = MongoAbility<[Action, Resource]>;
